export const enum NotificationIds {
  SYMPTOM_TRACKING_REMINDER = 1,
  PERIOD_REMINDER_D_MINUS_3 = 2,
  PERIOD_REMINDER_D_MINUS_1 = 3,
  PERIOD_REMINDER_D_PLUS_1 = 4,
  PERIOD_REMINDER_D_PLUS_4 = 5,
  PERIOD_REMINDER_D_PLUS_10 = 6,
}

export const PERIOD_REMINDER_IDS = [
  NotificationIds.PERIOD_REMINDER_D_MINUS_3,
  NotificationIds.PERIOD_REMINDER_D_MINUS_1,
  NotificationIds.PERIOD_REMINDER_D_PLUS_1,
  NotificationIds.PERIOD_REMINDER_D_PLUS_4,
  NotificationIds.PERIOD_REMINDER_D_PLUS_10,
];

const enum ActionTypes {
  SYMPTOM_TRACKING_REMINDER = 'symptomTrackingReminder',
  PERIOD_REMINDER = 'periodReminder',
}

export default ActionTypes;
